import { render, staticRenderFns } from "./PlayerMain.vue?vue&type=template&id=2dbba54b&scoped=true&"
import script from "./PlayerMain.vue?vue&type=script&lang=js&"
export * from "./PlayerMain.vue?vue&type=script&lang=js&"
import style0 from "./PlayerMain.vue?vue&type=style&index=0&id=2dbba54b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbba54b",
  null
  
)

component.options.__file = "PlayerMain.vue"
export default component.exports